import styled from "styled-components";
import colors from "../../../../../../../../shared/theme/colors";

export const CreditCardMethodContainer = styled.div`
  .info-container {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px 12px 22px;
    color: #455a64;
    font-size: 15px;
    background-color: ${colors.surfaceMuted};
    margin-top: 30px;
    font-weight: 500;
  }

  .info-container-error {
    background-color: #f9e0e0;
    color: #da3333;
    margin-bottom: 30px;
  }

  .title-container {
    margin-top: 30px;
  }

  .title-container-error {
    display: none;
  }
  .input-container {
    position: relative;
  }

  .icon-container {
    position: absolute;
    right: 16px;
    top: 22px;
    height: 48px;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .icon-container .help-tooltip {
    pointer-events: auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    cursor: help;
  }

  .help-tooltip:focus-visible {
    outline: 2px solid rgba(0, 0, 0, 0.3);
    outline-offset: 2px;
    border-radius: 4px;
  }

  .help-tooltip-text {
    position: absolute;
    bottom: calc(100% + 10px);
    right: -8px;
    width: max-content;
    max-width: 220px;
    padding: 8px 10px;
    background: #1f1f1f;
    color: #ffffff;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.4;
    text-align: left;
    white-space: normal;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    opacity: 0;
    visibility: hidden;
    transform: translateY(4px);
    transition:
      opacity 0.15s ease,
      transform 0.15s ease;
    z-index: 30;
  }

  .help-tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    right: 14px;
    border: 6px solid transparent;
    border-top-color: #1f1f1f;
  }

  .help-tooltip:hover .help-tooltip-text,
  .help-tooltip:focus .help-tooltip-text,
  .help-tooltip:focus-within .help-tooltip-text {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  form {
    gap: 10px;

    > div {
      display: flex;
      flex-direction: column;
      gap: 20px;

      .inputs-side-by-side {
        display: flex;
        gap: 20px;
      }
    }
  }

  .captcha-container {
    margin-top: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (min-width: 768px) {
    .info-container {
      padding: 12px 16px 12px 16px;
    }

    .inputs-side-by-side {
      display: flex;
      justify-content: space-between;

      > div {
        width: 100%;
      }
    }
  }
`;
